import React, { useContext, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import { AppContext } from '../../context';
import { translate as t } from 'hooks/useTranslations';
import FeaturesManager from 'utils/features/FeaturesManager';
import { TakeoverLayout } from '_lex/_layouts/TakeoverLayout';
import Chat from './Chat';

FeaturesManager.registerFeature({
  id: 'lex-ai',
  name: 'Lex AI',
  description: 'Enable Lex AI policy assistant (chatbot).',
  enabled: false,
  maxEnv: 'stage',
});

export default function LexAI() {
  const { isFeatureEnabled, hasAppPermission, setCurrentModule } = useContext(AppContext);

  useEffect(() => {
    setCurrentModule('lexAi');
  }, [setCurrentModule]);

  if (!isFeatureEnabled('lex-ai')) {
    return <Navigate to='/admin/dashboard' replace />;
  }
  if (!hasAppPermission('listIssuedManuals')) {
    return <Navigate to='/admin/dashboard' replace />;
  }

  return (
    <TakeoverLayout
      backUrl='/admin/dashboard'
      pageTitle={t('lexAi.pageTitle')}
      noPadding
    >
      <Box
        sx={{
          height: '100%',
          display: 'grid',
          gridTemplateRows: '1fr',
          minHeight: 0,
        }}
      >
        <Chat />
      </Box>
    </TakeoverLayout>
  );
}
